var _circle, _circle2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgUpdateCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 130,
    viewBox: "0 0 130 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 65,
    cy: 65,
    r: 65,
    fill: "#2898FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.3,
    cx: 65,
    cy: 65,
    r: 53,
    fill: "#2898FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46 84H45.25C45.25 84.4142 45.5858 84.75 46 84.75V84ZM46 75.0588L45.4697 74.5285C45.329 74.6691 45.25 74.8599 45.25 75.0588H46ZM75.0588 46L75.5892 45.4697C75.4485 45.329 75.2577 45.25 75.0588 45.25C74.8599 45.25 74.6691 45.329 74.5285 45.4697L75.0588 46ZM84 54.9412L84.5303 55.4715C84.671 55.3309 84.75 55.1401 84.75 54.9412C84.75 54.7423 84.671 54.5515 84.5303 54.4108L84 54.9412ZM54.9412 84V84.75C55.1401 84.75 55.3309 84.671 55.4715 84.5303L54.9412 84ZM46.75 84V75.0588H45.25V84H46.75ZM74.5285 46.5303L83.4697 55.4715L84.5303 54.4108L75.5892 45.4697L74.5285 46.5303ZM54.9412 83.25H46V84.75H54.9412V83.25ZM83.4697 54.4108L76.7638 61.1167L77.8244 62.1774L84.5303 55.4715L83.4697 54.4108ZM76.7638 61.1167L54.4108 83.4697L55.4715 84.5303L77.8244 62.1774L76.7638 61.1167ZM46.5303 75.5892L68.8833 53.2362L67.8226 52.1756L45.4697 74.5285L46.5303 75.5892ZM68.8833 53.2362L75.5892 46.5303L74.5285 45.4697L67.8226 52.1756L68.8833 53.2362ZM77.8244 61.1167L68.8833 52.1756L67.8226 53.2362L76.7638 62.1774L77.8244 61.1167Z",
    fill: "#027FF0"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateCircle);
export default __webpack_public_path__ + "static/media/updateCircle.644b6c13d0def0fa90dc8a538ef2acc2.svg";
export { ForwardRef as ReactComponent };